import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Hawaii = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Hawaii Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Standard disclosure form provided by the Hawaii Association of
          Realtors.
        </Text>

        <Text style={styles.listItem}>
          2. Disclosure Statement: Sellers must provide within 10 days of
          acceptance of an offer.
        </Text>

        <Text style={styles.listItem}>
          3. Termite Inspection: Often required due to local conditions.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – After the agreement is executed, the seller must complete a property
          disclosure in good faith within 10 calendar days.
        </Text>
      </View>
    </View>
  );
};

export default Hawaii;
